/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Graphictext1Inputs */

const ja_home_graphictext1 = /** @type {(inputs: Home_Graphictext1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN SHARES GAME CULTURE`)
};

const en_home_graphictext1 = /** @type {(inputs: Home_Graphictext1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN SHARES GAME CULTURE`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN SHARES GAME CULTURE" |
*
* @param {Home_Graphictext1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const home_graphictext1 = /** @type {((inputs?: Home_Graphictext1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Graphictext1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_graphictext1(inputs)
	return en_home_graphictext1(inputs)
});
export { home_graphictext1 as "home_graphicText" }